import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

export const createLoanCalculatorNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'build',
  text: translateFn('mnu_demo_schedule'),
  identity: '/secure/loan/calculator',
  permission: 'VIEW_DEMO_SCHEDULE',
}))

export default Loadable(() => import('./LoanCalculator'))
